/*
 * Copyright (C) 2026 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import { InjectionToken } from '@angular/core';
import { AdminEnrolment, AdminEnrolmentPerson, AdminEnrolmentRequest } from '../../models/playlist/admin-enrolment.model';
import { ObservableResult } from '../../store';

export const ADMIN_ENROLMENTS_DATA_SERVICE = new InjectionToken<AdminEnrolmentsDataService>(
  '[admin-enrolments] adminEnrolmentsDataService',
);

/**
 * V3 direct enrolment on a programme, collection or course, skipping its join method. Failures carry the API's
 * message, or none.
 */
export interface AdminEnrolmentsDataService {
  enrol(playlistUid: string, request: AdminEnrolmentRequest): ObservableResult<AdminEnrolment>;

  /** A CSV with an `email` column and the optional `first_name`, `last_name` and `external_id`; on a preview nobody is enrolled. */
  importCsv(playlistUid: string, file: File, options: { preview: boolean; notify: boolean }): ObservableResult<AdminEnrolment>;

  /** What enrolling one person would do, without enrolling them. */
  previewPerson(playlistUid: string, person: AdminEnrolmentPerson): ObservableResult<AdminEnrolment>;
}
